import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16a3 3 0 0 1 -3 3","key":"svg-0"}],["path",{"d":"M16 16a3 3 0 0 0 3 3","key":"svg-1"}],["path",{"d":"M12 16v4","key":"svg-2"}],["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -4","key":"svg-3"}],["path",{"d":"M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3","key":"svg-4"}]]

const IconAirConditioning = createReactComponent('outline', 'air-conditioning', 'AirConditioning', __iconNode);

export default IconAirConditioning;